import * as CSS from 'csstype';
import { CreativeUnitWithCustomizationsDto } from '../../../../../../api/src/creative-unit-package/models/creative-unit/creative-unit.dto';
import { LocaleDto } from '../../../../../../api/src/creative-unit-package/models/locale.dto';
import { CreativeUnitPackageDto } from '../../../../../../api/src/creative-unit-package/models/creative-unit-package.dto';

export { Status as CreativeUnitPackageStatus} from '../../../../../../api/src/creative-unit-package/creative-unit-package.entity';

export interface EntityValues {
	id: string;
	values: { [key: string]: any };
}

export interface creativeUnitValues extends EntityValues {
	layers:	creativeUnitLayerValues[];
}

export interface creativeUnitLayerValues extends EntityValues {

}

export interface CreativeUnitDimensions {
	width: number;
	height: number;
}

export class CreativeUnitSize {
	id?: string;
	name: string;
	category: CreativeUnitCategory;
	dimensions: {
		width: number;
		height: number;
	}
	locale?: LocaleDto;
}

export enum CreativeUnitCategory {
	SOCIAL_VIDEO = 'Social (Video)',
	SOCIAL_STATIC = 'Social (Static)',
	DISPLAY_STATIC = 'Display (Static)',
	DISPLAY_ANIMATED = 'Display (Motion)',
	VIDEO = 'Video',
	CUSTOM = 'Create Your Own'
}

export class CreativeUnitStyleItem {
	key: string;
	value: CSS.PropertyValue<any>;
}

export interface ElementClickedEventWithCreativeUnit {
	event: MouseEvent;
	creativeUnit: CreativeUnitWithCustomizationsDto
}

export interface ValidationErrorEvent {
	err: string;
	unitId: string;
	tabName: string;
}

export interface ChangeHistoryEvent {
	/** The ID of the package & creative unit that was changed. Used to identify
	 * where the change happened in the editor.
	*/
	packageId: string;
	creativeUnitId?: string;

	/** The ID of the layer that was changed. */
	changes: CreativeUnitPackageDto;
}

export interface AdStudioSnappingSettings {
	edgeSnapping: boolean;
	layerSnapping: boolean;
}
